import { j as e } from "../../../jsx-runtime-B6kdoens.js";
import { useContext as m } from "react";
import { a as i } from "../../../index-CROKJrb5.js";
import { c as s } from "../../../create-component-CBAeEoQ6.js";
import { F as n } from "../../../FormControlContext-C7A4R-3o.js";
import { Typography as a } from "../../Typography/index.js";
const f = s("FormControlLabel", ({ className: o, ...r }) => {
  const { id: t } = m(n);
  return /* @__PURE__ */ e.jsx(
    a,
    {
      size: "meta",
      className: i("cur-ml-2", o),
      id: `${t}-required`,
      ...r,
      children: "Required"
    }
  );
});
export {
  f as FormControlRequired
};
//# sourceMappingURL=index.js.map
